import React from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import ImageCarousel from './ImageCarousel';
import { HexagonNumber, FloatingShape, TechTag } from './GeometricElements';
interface Project {
  id: number;
  title: string;
  description: string;
  client: string;
  images: string[];
}
interface ProjectSectionProps {
  project: Project;
  isEven: boolean;
}
const ProjectSection = ({
  project,
  isEven
}: ProjectSectionProps) => {
  // For parallax effect
  const {
    scrollYProgress
  } = useScroll();
  const y = useTransform(scrollYProgress, [0, 1], [0, -100]);
  // Tech logos für verschiedene Projekte
  let techLogos = [{
    name: 'React',
    logoUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/nqESPSkQbn63Y5vyeJ1W53/react.svg'
  }, {
    name: 'TypeScript',
    logoUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/eBeRhwZUgy7sU7HWRcnHhj/typescript.svg'
  }, {
    name: '.NET',
    logoUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/ciEM1qLgaZYH3Pa1TVWkR8/Microsoft_.NET_logo.svg'
  }, {
    name: 'C#',
    logoUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/iV792C7XUL9CigqUXPbZH1/c-sharp.svg'
  }, {
    name: 'Electron',
    logoUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/2KnyDpzj4pRH1gspDP8EjF/electronjs-icon.svg'
  }];
  // Für Projekt 2 andere Technologien anzeigen
  if (project.id === 2) {
    techLogos = [{
      name: 'Blazor',
      logoUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/6Md6bEBfpU8YCugkko72MA/blazor.svg'
    }, {
      name: 'JavaScript',
      logoUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/hnHYBAgLQbtTHnuv2sXAMg/javascript-logo-svgrepo-com.svg'
    }, {
      name: 'C#',
      logoUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/dX93iWgAiLwBTXvwYzEBG6/c-sharp.svg'
    }, {
      name: '.NET',
      logoUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/m8ASX6aMKAPHvcvqWHcQbs/Microsoft_.NET_logo.svg'
    }, {
      name: 'Modbus',
      logoUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bDfxHJoBBUTeeNsZweGMwy/modbus-seeklogo.svg'
    }, {
      name: 'REST API',
      logoUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/rzXpVDhod6if2CVe6ZWX75/rest-api-icon.svg'
    }];
  }
  // Für Projekt 3 andere Technologien anzeigen (mit Modbus, ohne Electron)
  else if (project.id === 3) {
    techLogos = [{
      name: 'React',
      logoUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/nqESPSkQbn63Y5vyeJ1W53/react.svg'
    }, {
      name: 'TypeScript',
      logoUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/eBeRhwZUgy7sU7HWRcnHhj/typescript.svg'
    }, {
      name: '.NET',
      logoUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/ciEM1qLgaZYH3Pa1TVWkR8/Microsoft_.NET_logo.svg'
    }, {
      name: 'C#',
      logoUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/iV792C7XUL9CigqUXPbZH1/c-sharp.svg'
    }, {
      name: 'Modbus',
      logoUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bDfxHJoBBUTeeNsZweGMwy/modbus-seeklogo.svg'
    }];
  }
  // Für Projekt 4 andere Technologien anzeigen (Chargenrückverfolgung)
  else if (project.id === 4) {
    techLogos = [{
      name: 'React',
      logoUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/nqESPSkQbn63Y5vyeJ1W53/react.svg'
    }, {
      name: 'TypeScript',
      logoUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/eBeRhwZUgy7sU7HWRcnHhj/typescript.svg'
    }, {
      name: 'C#',
      logoUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/iV792C7XUL9CigqUXPbZH1/c-sharp.svg'
    }, {
      name: '.NET',
      logoUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/m8ASX6aMKAPHvcvqWHcQbs/Microsoft_.NET_logo.svg'
    }, {
      name: 'Flutter',
      logoUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/jSwWNVzpLNeMu9rBFVgVhq/flutterio-icon.svg'
    }, {
      name: 'REST API',
      logoUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/rzXpVDhod6if2CVe6ZWX75/rest-api-icon.svg'
    }];
  }
  // Für Projekt 5 andere Technologien anzeigen (Business Intelligence Dashboard)
  else if (project.id === 5) {
    techLogos = [{
      name: 'C#',
      logoUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/iV792C7XUL9CigqUXPbZH1/c-sharp.svg'
    }, {
      name: 'WinForms',
      logoUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/8ijMSfbNBBjKRL4DTdGiN7/Bildschirmfoto_2025-08-01_um_15.01.43.png'
    }, {
      name: '.NET',
      logoUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/m8ASX6aMKAPHvcvqWHcQbs/Microsoft_.NET_logo.svg'
    }, {
      name: 'Excel',
      logoUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/oW3a3Moy64QNMdJzfSsLcX/Microsoft_Office_Excel_%282019%E2%80%93present%29.svg'
    }];
  }
  return <motion.div className="mb-32 relative" initial={{
    opacity: 0,
    y: 50
  }} whileInView={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.8
  }} viewport={{
    once: true,
    margin: '-100px'
  }} data-id="element-187">
      <div className="absolute inset-0 overflow-hidden z-0" data-id="element-188">
        <motion.div style={{
        y
      }} className="relative w-full h-full" data-id="element-189">
          <FloatingShape shape="triangle" size={80} position={{
          top: '10%',
          left: isEven ? '5%' : '85%'
        }} delay={0.5} data-id="element-190" />
          <FloatingShape shape="hexagon" size={60} position={{
          top: '60%',
          left: isEven ? '85%' : '5%'
        }} delay={1.2} data-id="element-191" />
          <FloatingShape shape="square" size={40} position={{
          top: '30%',
          left: '50%'
        }} delay={0.8} data-id="element-192" />
          <FloatingShape shape="circle" size={50} position={{
          top: '80%',
          left: '30%'
        }} delay={1.5} data-id="element-193" />
        </motion.div>
      </div>

      {/* Project number indicator */}
      <div className="flex justify-center mb-8" data-id="element-194">
        <HexagonNumber number={project.id} data-id="element-195" />
      </div>

      <div className={`flex flex-col ${isEven ? 'md:flex-row' : 'md:flex-row-reverse'} gap-8 items-center relative z-10`} data-id="element-196">
        <div className="w-full md:w-1/2" data-id="element-197">
          <motion.div initial={{
          opacity: 0,
          x: isEven ? -30 : 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} viewport={{
          once: true
        }} data-id="element-198">
            {/* Redesigned project title with shadow and geometric accent */}
            <div className="relative mb-6" data-id="element-199">
              <h2 className="text-3xl font-bold text-gray-800 drop-shadow-sm relative z-10 pl-4" data-id="element-200">
                {project.title}
                <div className="absolute left-0 top-1/2 -translate-y-1/2 w-2 h-12 bg-[#9CC31C]" style={{
                clipPath: 'polygon(0 0, 100% 15%, 100% 85%, 0 100%)'
              }} data-id="element-201" />
              </h2>
              <div className="absolute -right-4 -top-4 opacity-10 z-0" data-id="element-202">
                <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-203">
                  <path d="M30 0L60 30L30 60L0 30L30 0Z" fill="#9CC31C" data-id="element-204" />
                </svg>
              </div>
            </div>
            <div className="text-gray-600 mb-4 whitespace-pre-line" data-id="element-205">
              {project.description}
            </div>

            {/* Headline for technologies */}
            <div className="relative mb-6 mt-6" data-id="element-206">
              <h3 className="text-lg font-semibold text-gray-700 pl-4 relative z-10" data-id="element-207">
                Im Projekt verwendete Technologien
                <div className="absolute left-0 top-1/2 -translate-y-1/2 w-2 h-8 bg-[#9CC31C]" style={{
                clipPath: 'polygon(0 0, 100% 15%, 100% 85%, 0 100%)'
              }} data-id="element-208" />
              </h3>
            </div>
            <div className="flex flex-wrap gap-3 mb-6" data-id="element-209">
              {techLogos.map((tech, i) => <TechTag key={i} name={tech.name} logoUrl={tech.logoUrl} data-id="element-210" />)}
            </div>
          </motion.div>
        </div>

        <div className="w-full md:w-1/2" data-id="element-211">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.4
        }} viewport={{
          once: true
        }} className="relative" data-id="element-212">
            {/* Angled frame around the carousel */}
            <div className="absolute inset-0 -m-3 bg-gradient-to-br from-gray-100 to-white z-0 shadow-lg" style={{
            clipPath: 'polygon(0 5%, 5% 0, 95% 0, 100% 5%, 100% 95%, 95% 100%, 5% 100%, 0 95%)',
            transform: isEven ? 'rotate(-1deg)' : 'rotate(1deg)'
          }} data-id="element-213" />
            {/* Decorative geometric accent */}
            <div className="absolute -right-4 -bottom-4 z-0" data-id="element-214">
              <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-215">
                <path d="M20 0L40 20L20 40L0 20L20 0Z" fill="#9CC31C" fillOpacity="0.2" data-id="element-216" />
              </svg>
            </div>
            <div className="relative z-10" data-id="element-217">
              <ImageCarousel images={project.images} projectTitle={project.title} data-id="element-218" />
            </div>
          </motion.div>
        </div>
      </div>
    </motion.div>;
};
export default ProjectSection;